module.exports = __webpack_public_path__ + "fonts/iconfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/iconfont.ttf?t=1620798987493
// module id = 993
// module chunks = 0